var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.items),function(item){return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(item.loading),expression:"item.loading"}],key:item.id,attrs:{"id":item.id}},[_c('div',{staticClass:"action p-3 d-flex justify-content-end"}),_c('div',{ref:item.id,refInFor:true,staticClass:"chart",style:({
        height: item.height + 'px',
        width: '100%',
      })})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }